<div class="not-found">
  <p class="not-found__number">
    404
  </p>
  <p class="not-found__text">
    Keresett oldal nem található
  </p>
</div>
